import React, { useEffect, useState } from "react";
import "./ResultChart.css";
import squidgameDictionary from "../db/database";

function ResultChart({ results }) {
  const [topThree, setTopThree] = useState([]);

  useEffect(() => {
    const sorted = results.sort(
      (prev, cur) => cur.confidence - prev.confidence
    );
    setTopThree(sorted.slice(0, 3));
  }, [results]);

  const getPercent = (rawConfidence) => {
    return rawConfidence.toString().slice(2, 4);
  };

  return (
    <div className="ResultChart">
      {topThree.length > 0 && (
        <>
          <ul className="ul-results">
            {topThree.map((item, index) => (
              <li className="li-result" id={`chart${index}`} key={index}>
                <img
                  className="li-result-image"
                  src={`/characterImages/${
                    squidgameDictionary[item.label].imageUrl
                  }`}
                  alt="face"
                />
                <div className="li-result-texts">
                  <span>{squidgameDictionary[item.label].name}</span>
                  <span>{getPercent(item.confidence)}%</span>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default ResultChart;
